import Women from '../../assets/woman-working-laptop.png';
import Union from '../../assets/Union.svg';
const DesktopLanding = ({ navigate }) => {
  return (
    <div className="relative min-h-screen bg-primary-50 overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 w-full h-auto mt-16 md:mt-28 content-end">
        <img src={Union} alt="" layout="fill" objectFit="cover" className="w-full h-[30%]" />
      </div>
      <div className="absolute right-0 bottom-0 top-[20%]" style={{ zIndex: '9' }}>
        <img
          src={Women}
          alt="Teacher working on laptop"
          layout="fill"
          objectFit="contain"
          objectPosition="right bottom"
          className="origin-bottom-right"
        />
      </div>
      {/* Content Container */}
      <div className="container max-w-7xl relative mx-auto px-4 sm:px-6 lg:px-6 relative h-screen">
        {/* Large "TEACHERS" Text */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <h1 className="mb-[35rem] sm:mb-[15rem] text-[60px] xs:text-[72px] sm:text-[110px] md:text-[140px] lg:text-[180px] xl:text-[240px] 2xl:text-[270px] 3xl:text-[340px]  font-black leading-[0.88] uppercase tracking-tight hero-text-gradient">
            TEACHERS
          </h1>
        </div>

        <div className="absolute h-full flex flex-col top-[40%]" style={{ zIndex: '99' }}>
          {/* Left Content */}
          <div className="w-full z-10 mt-16 sm:mt-24 md:mt-32 lg:mt-40">
            <div className="text-left">
              <h2 className="text-lg sm:text-xl md:text-2xl lg:text-3xl text-primary-text leading-tight font-medium mb-4">
                CONNECTING EXCEPTIONAL TEACHERS
                <br className="hidden sm:block" />
                WITH LEADING INSTITUTIONS
              </h2>
              <p className="text-sm sm:text-base md:text-lg lg:text-xl text-primary-text mb-6 sm:mb-8">
                Your One-Stop Platform for Finding Your Next Role in
                <br className="hidden sm:block" />
                Education or Your Next Great Hire
              </p>
              <button
                onClick={() => navigate('/login')}
                className="w-full sm:w-auto bg-primary-500 text-primary-50 px-4 sm:px-6 md:px-8 py-2 sm:py-3 md:py-4 rounded-full text-sm sm:text-base md:text-lg hover:bg-opacity-90 transition-colors duration-200"
              >
                Find your dream job
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DesktopLanding;

{
  /* Hero Image */
}

{
  /* <div className="absolute right-0 bottom-0 w-full lg:w-[60%] h-[50%] sm:h-[60%] lg:h-[80%] xl:mr-[-15rem]">
  <img
    src={Women}
    alt="Teacher working on laptop"
    className="w-full h-full object-contain object-right-bottom"
    style={{
      transform: 'scale(1.1)',
      transformOrigin: 'bottom right',
    }}
  />
</div> */
}